// components/CountryCodeSelector.jsx
import React, { useState, useRef, useEffect } from 'react';
import '../pages/css/CountryCodeSelector.css';

const countryCodes = [
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+1', name: 'USA', flag: '🇺🇸' },
  { code: '+44', name: 'UK', flag: '🇬🇧' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
  { code: '+81', name: 'Japan', flag: '🇯🇵' },
  { code: '+86', name: 'China', flag: '🇨🇳' },
  { code: '+49', name: 'Germany', flag: '🇩🇪' },
  { code: '+33', name: 'France', flag: '🇫🇷' },
  { code: '+39', name: 'Italy', flag: '🇮🇹' },
  { code: '+55', name: 'Brazil', flag: '🇧🇷' },
  { code: '+7', name: 'Russia', flag: '🇷🇺' },
  { code: '+82', name: 'South Korea', flag: '🇰🇷' },
  { code: '+34', name: 'Spain', flag: '🇪🇸' },
  { code: '+31', name: 'Netherlands', flag: '🇳🇱' },
  { code: '+46', name: 'Sweden', flag: '🇸🇪' },
  { code: '+41', name: 'Switzerland', flag: '🇨🇭' },
  { code: '+65', name: 'Singapore', flag: '🇸🇬' },
  { code: '+971', name: 'UAE', flag: '🇦🇪' },
  { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+20', name: 'Egypt', flag: '🇪🇬' },
];

const CountryCodeSelector = ({ value, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const selectedCountry = countryCodes.find(c => c.code === value) || countryCodes[0];

  const filteredCountries = countryCodes.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.code.includes(searchTerm)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    onChange(code);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="irp-country-selector">
      <button
        ref={buttonRef}
        type="button"
        className="irp-country-selector-btn"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span className="irp-country-flag">{selectedCountry.flag}</span>
        <span className="irp-country-code">{selectedCountry.code}</span>
        <svg className={`irp-country-arrow ${isOpen ? 'irp-country-arrow-open' : ''}`} width="12" height="12" viewBox="0 0 12 12">
          <path d="M6 8L1 3h10z" fill="currentColor"/>
        </svg>
      </button>

      {isOpen && (
        <div ref={dropdownRef} className="irp-country-dropdown">
          <div className="irp-country-search">
            <input
              type="text"
              className="irp-country-search-input"
              placeholder="Search country..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="irp-country-list">
            {filteredCountries.map((country) => (
              <button
                key={country.code}
                type="button"
                className={`irp-country-option ${country.code === value ? 'irp-country-option-active' : ''}`}
                onClick={() => handleSelect(country.code)}
              >
                <span className="irp-country-flag">{country.flag}</span>
                <span className="irp-country-name">{country.name}</span>
                <span className="irp-country-code">{country.code}</span>
              </button>
            ))}
            {filteredCountries.length === 0 && (
              <div className="irp-country-no-results">No countries found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryCodeSelector;